// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
// import TimeAgo from 'react-time-ago'
// import en from 'javascript-time-ago/locale/en'
// TimeAgo.locale( en )
import TimeAgo from 'timeago-react'

// Internal Dependencies:
import PageEvents from '../page/PageEvents'
// import Editable from 'components/Editable/Editable'
// import ContentBox from 'components/ContentBox/ContentBox'
// import Recaptchas from 'components/Recaptchas/Recaptchas'
// import PageHeader from './PageHeader'
// import Content from './Content'

// Redux:
import { getForumData, getForumTopicData, sendLike, sendReply, setNewRepliesNoticeAsSeen } from 'actions/forum'

const host = window.location.host

class Topic extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			replyText: ''
		}
	}

	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		window.scrollTo( 0, 0 )

		const { params } = this.props.match

		this.props.getForumData( params.forum )
		this.props.getForumTopicData( params.topic, false, false )
		this.startHeartBeat()
	}

	componentWillUnmount() {
		this.stopHeartBeat()
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		// window.scrollTo( 0, 0 )

		const { newRepliesAvailable } = this.props
		const { params, path } = this.props.match
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path

		if ( prevParams.forum != params.forum ) {
			this.props.getForumData( params.forum )
		}

		if ( prevParams.topic != params.topic ) {
			this.props.getForumTopicData( params.topic )
		}

		if ( newRepliesAvailable ) {
			setTimeout( () => {
				this.props.setNewRepliesNoticeAsSeen()
			}, 5000 )
		}
	}

	startHeartBeat = () => {
		const { params } = this.props.match

		this.setState( {
			beating: true
		})

		this.interval = setInterval(
			() => {
				this.props.getForumTopicData( params.topic, false, true )
			},
			15000
		)
	}

	stopHeartBeat = () => {
		this.setState( {
			beating: false
		})

		clearInterval( this.interval )
	}

	handleReplyTextChange = ( e ) => {
		this.setState({
			replyText: e.target.value
		})
	}

	handleSendReply = () => {
		const { sendReply } = this.props
		const { replyText } = this.state

		this.setState({
			replyText: ''
		})

		sendReply( replyText )
	}

	handleSendLike = ( e ) => {
		const { sendLike } = this.props
		const id = e.target.getAttribute( 'data-id' )

		sendLike( id, true )
	}

	handleSendUnlike = ( e ) => {
		const { sendLike } = this.props
		const id = e.target.getAttribute( 'data-id' )

		sendLike( id, false )
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { topic, newRepliesAvailable, match, userTimezoneOffset } = this.props
		const { replyText } = this.state
		const buttonDisabled = replyText ? false : true

		if ( ! topic ) {
			return null
		}

		document.title = topic.title.raw

		let markup = ''

		if ( topic.replies && Object.keys( topic.replies ).length ) {
			markup = Object.keys( topic.replies )
				.map( key => {
					let item = topic.replies[ key ],
						likesClass = item.has_liked ? '-likes -liked' : '-likes',
						time = new Date( item.date.iso )

					time.setMinutes( time.getMinutes() - userTimezoneOffset )

					return (
						<div
							key={ item.id }
							id={ `reply-${item.id}` }
							className="-forum-reply"
						>
							<div className="-inner">
								<header>
									<div className="-name" dangerouslySetInnerHTML={ { __html: item.author.name } } />
									<div className="-date">
										{/*<TimeAgo timeStyle="twitter">{ item.date.iso }</TimeAgo>*/}
										<TimeAgo datetime={ time } />
									</div>
								</header>

								<main>
									<div className="-text" dangerouslySetInnerHTML={ { __html: item.content.rendered } }></div>
								</main>

								<footer>
									<div className={ likesClass }>
										<i
											className="icon-heart-o"
											aria-hidden="true"
											onClick={ this.handleSendLike }
											data-id={ item.id }
										/>

										<i
											className="icon-heart"
											aria-hidden="true"
											onClick={ this.handleSendUnlike }
											data-id={ item.id }
										/>

										<span>{ item.likes }</span>
									</div>
								</footer>
							</div>
						</div>
					)
				})
		}

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<PageEvents />

				{ newRepliesAvailable &&
					<div className="forum-new-replies-available">
						<i className="icon-chat-bubble" aria-hidden="true"></i>

						New replies available
					</div>
				}

				<div className="content-body-wrap">
					<div className="content-body forum-topic">
						<div className="page-title">
							<h1 dangerouslySetInnerHTML={ { __html: topic.title.rendered } }></h1>

							<div className="page-intro" dangerouslySetInnerHTML={ { __html: topic.content.rendered } }></div>

							{ ! topic.is_403 &&
								<div className="-view-count">
									<i className="icon-eye" aria-hidden="true" />

									<span>{ topic.view_count }</span>
								</div>
							}
						</div>

						{ ! topic.is_403 &&
							<div className="content-body-text">
								<div className="forum-replies">
									{ markup }
								</div>

								<div className="forum-leave-reply">
									<h3>Write a response</h3>

									<i className="icon-chevron-down" aria-hidden="true" />

									<textarea
										rows="10"
										value={ replyText }
										onChange={ this.handleReplyTextChange }
									/>

									<button className="button" onClick={ this.handleSendReply } disabled={ buttonDisabled } >Post</button>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.props.isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.forum.isLoading,
		topic: state.forum.selectedTopic,
		newRepliesAvailable: state.forum.newRepliesAvailable,
		userTimezoneOffset: state.site.userTimezoneOffset,
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getForumData( slug ) {
			dispatch( getForumData( slug ) )
		},

		getForumTopicData( slug, archivePageNumber, requestOnly ) {
			dispatch( getForumTopicData( slug, archivePageNumber, requestOnly ) )
		},

		sendLike( id, liked ) {
			dispatch( sendLike( id, liked ) )
		},

		sendReply( content ) {
			dispatch( sendReply( content ) )
		},

		setNewRepliesNoticeAsSeen() {
			dispatch( setNewRepliesNoticeAsSeen() )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Topic )



// WEBPACK FOOTER //
// ./views/main/forum/Topic.jsx